import React from 'react';
import { formatPhoneNumber, firstNameFirst } from "../../helpers/formatting";
import { formatTimeUTCToCST } from "../../helpers/Tools";
import MiniSpinner from "../common/minispinner.js";

function getStatusClass(status) {
    switch (status) {
        case 'PENDING':
        case 'INVITED':
        case 'GUEST_WAITING_FOR_APPROVAL':
        case 'GUEST_ALLOWED':
        case 'SENT':
        case 'SUCCESS': // obsolete
        case 'JOINED':
            return { icon: "icon-list-check", container: "share-success-msg" };
        case 'GUEST_NOT_ALLOWED':
        case 'KICKED_OUT':
        case 'CANCELED':
            return { icon: "icon-cancel-denied-removed", container: "share-not-allowed-msg" }; // Class used to hide buttons via css too
        case 'EXPIRED': 
        case 'FAILED':
            return { icon: "icon-close", container: "share-error-msg" };
        case 'CLOSED':
        case 'UNKNOWN':
        default:
            return '';
    }
};

function getStatusMsg(status, participantName, requestedTime, statusUpdateTime) {
    switch (status) {
        case 'PENDING':
        case 'INVITED':
        case 'GUEST_WAITING_FOR_APPROVAL':
        case 'GUEST_ALLOWED':
        case 'SENT':
        case 'SUCCESS': // obsolete
        case 'JOINED':
            return `Link sent to ${participantName} at ${formatTimeUTCToCST(requestedTime)}`;
        case 'GUEST_NOT_ALLOWED':
            return `${participantName} was denied at ${formatTimeUTCToCST(statusUpdateTime)}`;
        case 'KICKED_OUT':
            return `${participantName} was removed at ${formatTimeUTCToCST(statusUpdateTime)}`;
        case 'CANCELED':
            return `Invite cancelled for ${participantName} at ${formatTimeUTCToCST(statusUpdateTime)}`;
        case 'EXPIRED': 
            return `Link expired for ${participantName} at ${formatTimeUTCToCST(statusUpdateTime)}`;
        case 'FAILED':
            return `Link failed to ${participantName} at ${formatTimeUTCToCST(requestedTime)}`;
        case 'CLOSED':
        case 'UNKNOWN':
        default:
            return '';
    }
};

const AppointmentShareHistoryItem = (props) => {
    const { shareLinkItem, targetId } = props;
    const shareLinkTarget = shareLinkItem.target.indexOf('@') === -1 ? formatPhoneNumber(shareLinkItem.target) : shareLinkItem.target;
    const shareLinkError = shareLinkItem.errorCode && shareLinkItem.errorCode !== '0' && <span className="share-link-sec__error-code"> (E-{shareLinkItem.errorCode})</span>;
    const participantName = shareLinkItem.token && shareLinkItem.token.participantName ? shareLinkItem.token.participantName : "";
    const statusClass = getStatusClass(shareLinkItem.status);
    const statusMsg = getStatusMsg(shareLinkItem.status, participantName, shareLinkItem.requestedAtUtc, shareLinkItem.statusUpdatedAtUtc);

    return (
        <div className={`share-link-sec ${statusClass.container}`}>
            <div className="details-icon-prepend">
                <div className="icon-col">
                    <span className={statusClass.icon} />
                </div>
                <div className="details-col">
                    <div>{shareLinkTarget}{shareLinkError}</div>
                    {statusMsg && <div className="share-link-date">{statusMsg}</div>}
                    {props.showCancelResendLinks &&
                        <div className="share-link-btns">
                            <button className="btn text-btn" onClick={() => props.onCancelInviteClick(shareLinkItem)}>CANCEL INVITE</button><div className="btn-divider"><span>|</span></div>
                            <button className="btn text-btn" id={targetId} onClick={() => props.onResendInviteClick(shareLinkItem, targetId)}>RESEND</button>
                            {(shareLinkItem.canceling || shareLinkItem.reSending) &&
                                <div className="overlay-loading-container row">
                                    <div className="col-12 align-self-center">
                                        <MiniSpinner />
                                    </div>
                                </div>
                            }
                        </div>
                    }
                </div>
            </div>
        </div>
    );
}

export default AppointmentShareHistoryItem;